<script>
import ScheduleList from '../SchedulesList'
export default {
  name: 'scheduled-schedules',
  extends: ScheduleList,
  computed: {
    tabSchedule () {
      return this.$store.getters.awaitSchedule
    }
  },
  mounted () {
    if (this.$store.getters.awaitSchedule.length === 0) {
      this.$store.dispatch('getAwaitSchedule')
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?0706aa62